import _ from 'lodash';
import { post } from './agent';

const feedbackItemFiles =
  (feedbackItemFilesUrl) =>
  (id = '') => {
    const url = _([feedbackItemFilesUrl, id]).compact().join('/');

    return {
      upload: (body) => post(url, body),
    };
  };

export default feedbackItemFiles;
